import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImage403Svg';

export const ResponsesImage403 = createResponsesImage({
  name: 'ResponsesImage403',
  component,
});
